<template>
	<v-layout v-if="!dataSame && contestId">
		<v-flex xs6>
			<old-version-marker/>
			<agency-choose-actions
				:value="old"
				:readonly="true"
			/>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<agency-choose-actions
				:value="current"
				:readonly="true"
				:old-version="old"
			/>
		</v-flex>
	</v-layout>
</template>

<script>
	import OldVersionMarker from "../../offer/compareComponents/oldVersionMarker";
	import NewVersionMarker from "../../offer/compareComponents/NewVersionMarker";
	import AgencyChooseActions from "../components/AgencyChooseActions";

	export default {
		name: "AgencyCompareActions",
		components: {AgencyChooseActions, NewVersionMarker, OldVersionMarker},
		computed: {
			dataSame () {
				if (this.old === undefined || this.current === undefined) {
					return false;
				}

				let oldCopy = JSON.parse(JSON.stringify(this.old));
				let currentCopy = JSON.parse(JSON.stringify(this.current));

				//id zmieniają się wraz z zapisywaniem projektu, więc nie możemy po nich porównywać
				for (let action of oldCopy) {
					action.id = 0;
				}

				for (let action of currentCopy) {
					action.id = 0;
				}

				let comparisonResult = JSON.stringify(oldCopy) === JSON.stringify(currentCopy);
				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			old: {},
			current: {},
			contestId: {},
		}
	};
</script>

<style scoped>

</style>
